module.exports = __webpack_public_path__ + "img/tu1-3.e4050d4f.png";